// src/components/calendar/YearView.tsx
import { addMonths } from "date-fns"
import { MonthCalendar } from "./MonthCalendar"

interface YearViewProps {
  currentDate: Date
  onDayClick?: (date: Date) => void
  filterType?: "all" | "task" | "holiday"
}

export function YearView({ currentDate, onDayClick, filterType }: YearViewProps) {
  const months = Array.from({ length: 12 }, (_, i) =>
    addMonths(new Date(currentDate.getFullYear(), 0, 1), i)
  )

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
      {months.map((month) => (
        <MonthCalendar key={month.toString()} date={month} onDayClick={onDayClick} filterType={filterType} />
      ))}
    </div>
  )
}